module.exports = __webpack_public_path__ + "fonts/e79bfd88537def476913f3ed52f4f4b3-MaterialIcons-Regular.eot";